export default "__VITE_ASSET__60lCSqDr__"